import { useMemo } from 'react'

import { propEq } from 'ramda'
import useSWR from 'swr'

import { access as ACCESS } from '@driftt/traffic-control'

import { WidgetCacheAPI } from 'api/index'
import { ALL_LOCALE_OPTIONS, resolveLocaleOptions } from 'constants/Locales'

const fetcher = (url: string) => WidgetCacheAPI.get(url).then((res) => res.data)

export default function useLocaleOptions(defaultWidgetLocale: string) {
  const {
    data: widgetSupportedLocales,
    error,
    isLoading,
  } = useSWR<string[]>('/child_embeds/enabledLanguages', fetcher)
  //access
  const hasMultiLanguageEnabled = ACCESS.hasGates('multi_language')
  const hasDowngradedMultiLanguage =
    !hasMultiLanguageEnabled && ACCESS.hasGates('is_multi_language_downgrade')
  //locales supported by the org in widget, also makes up options in the Select
  const widgetSupportedLocaleOptions: { label: string; value: string }[] =
    useMemo(
      () =>
        widgetSupportedLocales
          ? resolveLocaleOptions(widgetSupportedLocales) || []
          : [],
      [widgetSupportedLocales]
    )
  //default option for the Select
  const defaultOption: { label: string; value: string } = useMemo(() => {
    const absoluteDefault = {
      label: 'English',
      value: 'en',
    }
    return (
      widgetSupportedLocaleOptions.find(propEq('value', defaultWidgetLocale)) ||
      ALL_LOCALE_OPTIONS.find(propEq('value', defaultWidgetLocale)) ||
      absoluteDefault
    )
  }, [widgetSupportedLocaleOptions, defaultWidgetLocale])

  return {
    isLoading: isLoading || error,
    isError: error,
    hasMultiLanguageEnabled,
    hasDowngradedMultiLanguage,
    localeOptions: widgetSupportedLocaleOptions,
    defaultLocaleOption: defaultOption,
  }
}
